/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tysiav2IconButtonPause1/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Tysiav2IconButtonPause1({
  children,
  viewPath = "/DesignSystem/Svgs/Tysiav2IconButtonPause1",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 14,
  height = 14,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#000"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="Tysiav2IconButtonPause1.Svg"
  data-view-path={viewPath}
 viewBox="0 0 14 14"
 style={{'--as-1-Z1YwkHs': alignSelf,'--mt-2-Z1YwkHs': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-Z1YwkHs': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-Z1YwkHs': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-Z1YwkHs': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-Z1YwkHs': opacity,'--w-10-Z1YwkHs': typeof width === 'number' ? `${width}px` : width,'--h-11-Z1YwkHs': typeof height === 'number' ? `${height}px` : height,'--f-12-Z1YwkHs': fill,'--a-7-Z1YwkHs': isAnimated ? animation : "none",'--sd-8-Z1YwkHs': isAnimated ? strokeDashoffset : 0,'--sd-9-Z1YwkHs': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="Tysiav2IconButtonPause1.SvgPath"
  data-view-path={viewPath}
 fillRule="evenodd"
 clipRule="evenodd"
 d="M5.469 1.82a1.5 1.5 0 10-3 0v10.4a1.5 1.5 0 003 0V1.82zm6.062 0a1.5 1.5 0 00-3 0v10.4a1.5 1.5 0 003 0V1.82z"
 style={{'--f-12-Z1YwkHs': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}